import { createSlice } from '@reduxjs/toolkit';

// `common` is the host page's state object — `siteSettings` and `userId`, read from
// `window.__INITIAL_STATE_IW_<VIEW>__`. Every view has one and every view's is the same, so this
// lives here rather than ten times over under the view folders.
//
// **It declares no reducers on purpose.** Nothing writes to `common`: each `create<View>Store`
// seeds it through `preloadedState` and the rest of the tree only reads it. A slice with an empty
// `reducers` map is how RTK expresses "hold this value and never change it" — `configureStore`
// requires a reducer for every key, so the value cannot simply be dropped into `preloadedState`
// without one.
const commonSlice = createSlice({
  name: 'common',
  initialState: {},
  reducers: {},
});

export default commonSlice.reducer;
